import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {useNavigate} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import Premium from 'shared/ui/icons/Premium';
import Dollar from 'shared/ui/icons/Dollar';
import {isTranslate} from 'shared/lib/lang';

import ModalBlockButton from '../../../../shared/ui/Button/ModalBlockButton/ModalBlockButton';

import styles from './AddAutoRenewalModal.module.scss';

interface IAddAutoRenewalModalProps {
    isOpen: boolean;
    handleClose: () => void;
}

const AddAutoRenewalModal: React.FC<IAddAutoRenewalModalProps> = ({isOpen, handleClose}) => {
    const navigate = useNavigate();

    const handleChooseTariff = () => {
        handleClose();
        navigate(AppUrls.TARIFFS);
    };
    
    return (
        <MainModal
            header={t`Автопродление`}
            open={isOpen}
            handleClose={handleClose}
            className={styles.autoRenewalModal}
        >
            <>
                <ModalBodyWrapper>
                    <div className={styles.content}>
                        <div className={styles.icon}>
                            {isTranslate() ? <Dollar /> : <Premium />}
                        </div>
                        <span className={styles.text}>
                            {t`Автопродление можно активировать при оплате`}
                            <br/> {t`или продлении тарифа. Отключается в любой момент`}.
                        </span>
                    </div>
                </ModalBodyWrapper>
                <ModalBlockButton
                    primaryButtonText={t`Выбрать тариф`}
                    primaryButtonType="button"
                    primaryButtonOnClick={handleChooseTariff}
                    secondaryButtonOnClick={handleClose}
                />
            </>
        </MainModal>
    );
};

export default AddAutoRenewalModal;